import React from 'react';
import { Helmet } from 'react-helmet';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import LoginForm from './components/LoginForm';

const Login = () => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) return null;
  // ถ้ายังไม่ verify email → ไปหน้า verify (กันเด้งสลับกับ /main-dashboard ผ่าน EmailVerificationGuard)
  if (isAuthenticated && localStorage.getItem('pending_verification_email')) {
    return <Navigate to="/email-verification" replace />;
  }
  if (isAuthenticated) return <Navigate to="/main-dashboard" replace />;

  return (
    <>
      <Helmet>
        <title>Sign In | Roomwork.ai - Professional Design Platform</title>
        <meta
          name="description"
          content="Access your Roomwork.ai account. Sign in to use AI-powered design tools for professional interior design and architectural visualization." />
      </Helmet>

      <div className="h-screen overflow-hidden flex">
        {/* Left Side - Full Screen Image */}
        <div className="hidden lg:flex lg:w-1/2 relative overflow-hidden bg-black items-center justify-start">
          <img
            src="/assets/images/login-registration-hero.png"
            alt="Modern luxury interior design showcase"
            className="h-full object-contain object-left" />
        </div>

        {/* Right Side - Login Form */}
        <div className="w-full lg:w-1/2 flex items-center justify-center bg-black relative overflow-y-auto">
          <div className="absolute inset-0 bg-black"></div>
          <div className="relative z-10 w-full max-w-md px-8">
            <LoginForm />
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;